import { createRouter, createWebHistory } from 'vue-router';
import RegistroCliente from '../components/RegistroCliente.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../components/HomePage.vue')
  },
  {
    path: '/registro-cliente',
    name: 'registro-cliente',
    component: RegistroCliente
  },
  
  
  
  {
    path: '/registro',
    name: 'registro',
    component: () => import('../components/RegistroPage.vue')
  },
  {
    path: '/cliente/:id',
    name: 'cliente-perfil',
    component: () => import('../components/ClientePerfil.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
